import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default function ProfileItem({
  leftIcon,
  rightIcon,
  children,
  footer,
  muted,
  className = '',
  contentClassName = '',
  cerberId = ''
}) {
  return (
    <section className={`${styles.root} ${className}`}>
      <div
        className={`${styles.content} ${contentClassName}`}
        data-cerber-id={cerberId}>
        {leftIcon}
        <h5 disabled={muted}>{children}</h5>
        {rightIcon}
      </div>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </section>
  )
}

ProfileItem.propTypes = {
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  muted: PropTypes.bool,
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  cerberId: PropTypes.string
}
